import moment from "moment";

const PrescriberDetails = ({
  prescription,
  prescriberDetails,
  registrarDetails,
  displayIndication,
}) => (
  <div className="inputs-div">
    <div className="row mt-5 font-size-16 gray bold">Prescriber Details</div>
    <div className="row mt-3">
      <div className="row" style={{ paddingLeft: "0", paddingRight: "0" }}>
        <div className="col-md-6 prescriber-details-inputs gray">
          {prescriberDetails.first_name
            ? "Prescribing Physician:"
            : "Connected Registrar:"}
          <input
            value={
              (prescriberDetails.first_name ??
                registrarDetails.first_name ??
                "") +
              " " +
              (prescriberDetails.last_name ?? registrarDetails.last_name ?? "")
            }
            className="gray"
            disabled
          />
        </div>
        <div className="col-md-6 prescriber-details-inputs gray">
          Name of treating Hospital:
          <input
            value={
              prescriberDetails?.name_and_address_hospital ??
              registrarDetails?.name_and_address_hospital ??
              ""
            }
            className="gray"
            disabled
          />
        </div>
      </div>
      <div className="row" style={{ paddingLeft: "0", paddingRight: "0" }}>
        <div className="col-md-6 prescriber-details-inputs gray">
          Patient Date of Birth:
          <input
            value={moment(prescription?.patient?.dob).format("DD / MM / YYYY")}
            className="gray"
            disabled
          />
        </div>
        <div className="col-md-6 prescriber-details-inputs gray">
          Patient Category
          <input
            value={prescription?.patient?.patient_type || ""}
            className="gray"
            disabled
          />
        </div>
      </div>
      <div className="row" style={{ paddingLeft: "0", paddingRight: "0" }}>
        <div className="col-md-6 prescriber-details-inputs gray">
          Indication:
          <input value={displayIndication() || ""} className="gray" disabled />
        </div>
        <div className="col-md-6 prescriber-details-inputs gray">
          Molecule:
          <input
            value={prescription?.product || ""}
            className="gray"
            disabled
          />
        </div>
      </div>
      <div className="row" style={{ paddingLeft: "0", paddingRight: "0" }}>
        <div className="col-md-6 prescriber-details-inputs"></div>{" "}
        {prescription?.high_tech_prescription_date && (
          <div className="col-md-6 prescriber-details-inputs gray">
            High Tech Prescription Date:
            <input
              value={moment(prescription?.high_tech_prescription_date).format(
                "DD / MM / YYYY"
              )}
              className="gray"
              disabled
            />
          </div>
        )}
      </div>
    </div>
  </div>
);
export default PrescriberDetails;
